import React from 'react';
import { Box, Caption, Flex } from '@mediahuis/chameleon-react';
import parse from 'html-react-parser';
import styled from 'styled-components';
import { styles } from './styles/';
import { STATUSES } from './enums';
import PhoneImg from './img/phone.svg';
var StatusIcon = styled.div.withConfig({
  displayName: "PhoneInfo__StatusIcon",
  componentId: "sc-19oqw1x-0"
})(["display:block;width:10px;height:10px;border-radius:50%;background-color:", ";margin-right:10px;"], function (props) {
  switch (props.output) {
    case STATUSES.CLOSED:
    case STATUSES.HOLIDAY:
    case STATUSES.OPENSOON:
    case STATUSES.RESTDAY:
      return styles.statusColors.inactive;

    default:
      return styles.statusColors.active;
  }
});
var PhoneIcon = styled.div.withConfig({
  displayName: "PhoneInfo__PhoneIcon",
  componentId: "sc-19oqw1x-1"
})(["margin-left:9px;background-image:url(", ");width:56px;height:56px;background-size:contain;background-repeat:no-repeat;background-position:center;"], PhoneImg);

var PhoneInfo = function PhoneInfo(_ref) {
  var componentData = _ref.componentData;
  var mainText = componentData.mainText,
      editText = componentData.editText,
      output = componentData.output,
      settings = componentData.settings;
  var closedInfoText = settings.closedInfoText,
      closed = settings.closed;
  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    mr: 4
  }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(PhoneIcon, null), /*#__PURE__*/React.createElement(StatusIcon, {
    output: output.status
  }))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Caption, {
    level: 2
  }, parse(mainText)), /*#__PURE__*/React.createElement(Caption, {
    level: 2
  }, parse(closed ? closedInfoText : editText))));
};

export default PhoneInfo;